<script>
import { chatComputed, chatMethods } from '@state/chatHelper'
import store from '@state/store'
import BaseSelect from '@components/sBase/_base-select.vue'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import PrivacyPolicyDialog from '@components/privacy-policy-popup.vue'
import {
  reasonProviderComputed,
  reasonProviderMethods,
} from '@state/reasonProviderHelper'
import { providerChatService } from '@/src/services/safehaven/ProviderChatService'

export default {
  components: { BaseSelect, PrivacyPolicyDialog },
  page: {
    title: 'Secure Chat',
    meta: [{ name: 'description', content: 'The Secure Chat page.' }],
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      selectedReason: null,
      selectedProvider: null,
      user: null,

      isShowAlert: false,
      userData: null,
      patientCredential: null,
    }
  },
  computed: {
    ...chatComputed,
    ...reasonProviderComputed,
    getData() {
      if (this.getReasonProviderDetails) {
        return this.getReasonProviderDetails
      } else return null
    },
    reasons() {
      if (this.getReasonProviderDetails) {
        return this.getReasonProviderDetails.reason
      } else {
        return []
      }
    },
    providers() {
      if (this.getReasonProviderDetails) {
        return this.getReasonProviderDetails.provider_type
      } else {
        return []
      }
    },
    socketURL() {
      if (
        this.getReasonProviderDetails &&
        this.getReasonProviderDetails.socketURL
      ) {
        return this.getReasonProviderDetails.socketURL
      } else {
        return null
      }
    },
  },
  beforeMount() {
    if (store.state.chat.chatConnected === true) {
      this.navigateToScreen('chat-in-progress')
    }
  },
  mounted() {
    this.userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.setReasonProviderDetails()
    this.getCredential()
  },
  methods: {
    ...chatMethods,
    ...reasonProviderMethods,
    goBack() {
      this.$router.go(-1)
    },
    getCredential() {
      providerChatService
        .getCredential(this.userData.user.user_id)
        .then((res) => {
          this.patientCredential =
            res.data && res.data.credential && res.data.credential.length
              ? res.data.credential[0].credential_name
              : null
        })
    },
    startChat() {
      this.user = {
        credential_id: this.patientCredential,
        patient_id: `${this.userData.user.roles.patient}`,
        patient_name:
          this.userData.user.first_name + ' ' + this.userData.user.last_name,
        provider_type: this.selectedProvider.provider_type,
        reason_for_visit: this.selectedReason.reason_name,
        socketURL: this.socketURL,
        org_name: this.userData.user.user_org_details[0].org_name,
      }
      store.dispatch('chat/setChatDetails', this.user).then(() => {
        this.navigateToScreen('chat-in-progress')
      })
    },
    showAlert() {
      this.isShowAlert = true
    },
    hideAlert() {
      this.isShowAlert = false
    },
  },
}
</script>

<template>
  <v-container>
    <PrivacyPolicyDialog
      v-if="isShowAlert"
      :show-alert="isShowAlert"
      @close-dialog="hideAlert"
      @proceed="startChat"
    ></PrivacyPolicyDialog>
    <v-overlay v-model="loading">
      <v-progress-circular
        :size="140"
        :width="14"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-row>
      <div class="pa-3">
        <v-row class="backButtonContainer mt-8">
          <v-img
            :src="require('@assets/images/safehaven/back.png')"
            height="10"
            width="10"
            class="ma-2"
          ></v-img>
          <a class="clickable primary--text" @click="goBack">Back</a>
        </v-row>
      </div>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="8"
        md="5"
        lg="4"
        xl="3"
        class="mr-auto ml-2"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <h3 class="peerHeading">Secure Chat</h3>
        <div :class="$style.text"
          >{{ $route.params.clientId }} ensures clinicians can seek support for
          burnout, career fatigue, and mental health reasons without the fear of
          undue repercussions to their medical license.</div
        >
        <BaseSelect
          v-model="selectedReason"
          :items="reasons"
          item-text="reason_name"
          item-value="id"
          class="mt-6"
          label="Select reason"
        ></BaseSelect>
        <BaseSelect
          v-model="selectedProvider"
          class="mt-6"
          :items="providers"
          item-text="provider_type"
          item-value="id"
          label="Select type of provider"
        ></BaseSelect>
        <div>
          <v-btn
            type="button"
            class="mt-6 my-auto clickable"
            :class="[
              'primary-btn',
              'full-width-btn',
              (!selectedReason || !selectedProvider) && 'disabled-btn',
            ]"
            @click="showAlert"
          >
            Start Secure Chat
          </v-btn>
        </div>
      </v-col>
      <v-col v-if="!notDesktop" align="center" cols="12" md="6" lg="6" xl="6">
        <v-img
          :class="$style.imgStyle"
          :src="require('@assets/images/safehaven/HealthChat.svg')"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.text {
  margin: 0.5rem auto;
  font-size: 14px;
  line-height: 22.5px !important;
  color: #2c3a4b;
}
.text::first-letter {
  text-transform: capitalize !important;
}
.title {
  font-size: 28px;
  font-weight: 400;
}
.imgStyle {
  width: 70%;
}
.fullWidthBtn {
  width: 80%;
  text-transform: unset !important;
}
@media screen and (max-width: 960px) {
  .fullWidthBtn {
    width: 90%;
  }
}
</style>

<style scoped>
.peerHeading {
  font-size: 22px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}

.appoinment {
  font-size: 14px !important;
  font-weight: 700;
  line-height: 22.5px !important;
}

.backButtonContainer {
  align-items: center;
  padding: 10px;
}

/deep/ .textField input::placeholder {
  color: #000 !important;
  opacity: 1;
}
/deep/
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  cursor: pointer !important;
}
/deep/ .v-input input {
  font-size: 14px !important;
  cursor: pointer !important;
}
/deep/ .v-input input::placeholder {
  color: #000 !important;
}
/deep/ .v-input {
  font-size: 14px !important;
}
/deep/ .v-list-item__title {
  font-size: 14px !important;
}
</style>
